import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import './styles/global.scss'
import './styles/dorm-admin.scss'
import { installDialogGlobals } from './utils/dialog'
import { installMobileViewportGuard } from './utils/mobileViewport'

function bootstrap() {
  installMobileViewportGuard()
  store.dispatch('initAuth').catch(() => {})
  const app = createApp(App)
  app.use(store)
  app.use(router)
  app.use(ElementPlus, { locale: zhCn })
  installDialogGlobals(app)
  app.mount('#app')
}

bootstrap()
